import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../services/user/user.service';
import {NotificationService} from '../../../services/common/notification.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: UntypedFormGroup;

  constructor(private dialogRef: MatDialogRef<ResetPasswordComponent>,
              private formBuilder: UntypedFormBuilder,
              private userService: UserService,
              private notificationService: NotificationService
  ) {
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  close() {
    this.dialogRef.close();
  }

  resetPassword() {
    const mail = this.resetPasswordForm.controls.email?.value;
    if (this.resetPasswordForm.valid) {
      this.dialogRef.close();
      this.userService.resetPassword(mail).subscribe(() => {
        this.notificationService.openSnackBar('Passwort wurde zurückgesetzt.');
      }, error => {
        this.notificationService.openSnackBar(error);
      });
    }
  }

}
